import { render, staticRenderFns } from "./purpose.vue?vue&type=template&id=14dbed14"
import script from "./purpose.vue?vue&type=script&lang=ts"
export * from "./purpose.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports